import { FeedbackBanner } from "@/core/components/feedback-banner";
import { LoadingSpinner } from "@/core/components/loading-spinner";
import { Typography } from "@/core/components/ui/typography";
import { getErrorMessage } from "@/core/api/errors";
import { PayBreakdownPaneShell } from "@/payroll/pay-breakdown/pay-breakdown-pane-shell";
import {
  AMOUNT_COLUMN,
  LINES_COLUMN,
  SelectCol,
  TECHNICIAN_COLUMN,
} from "./cols";
import { StAdjustmentsPreviewHeader } from "./st-adjustments-preview-header";
import { StAdjustmentsRollupTable } from "./st-adjustments-rollup-table";
import { useStAdjustmentsSection } from "./st-adjustments-section";

const EMPTY_SELECTION = new Set<number>();
const noAction = () => {};
const PREVIEW_SELECT_COLUMN = SelectCol({
  disabled: true,
  selectedTechnicianIds: EMPTY_SELECTION,
  allPushableSelected: false,
  somePushableSelected: false,
  pushableCount: 0,
  onToggleAll: noAction,
  onToggle: noAction,
});
const PREVIEW_COLUMNS = [
  PREVIEW_SELECT_COLUMN,
  TECHNICIAN_COLUMN,
  AMOUNT_COLUMN,
  LINES_COLUMN,
];

export const StAdjustmentsPreview = () => {
  const { isLoading, summaryError, byTechnician } = useStAdjustmentsSection();
  return (
    <PayBreakdownPaneShell
      fillHeight
      gap="lg"
      variant="pane"
      className="h-full opacity-75"
    >
      {summaryError && !isLoading && (
        <FeedbackBanner variant="error" iconSize="sm">
          <Typography variant="bodyW2">
            {getErrorMessage(summaryError)}
          </Typography>
        </FeedbackBanner>
      )}

      {isLoading && <LoadingSpinner className="h-40" color="primary" />}

      {!isLoading && !summaryError && byTechnician.length === 0 && (
        <Typography variant="bodyW2" textColor="secondary">
          No named technician users with valid ServiceTitan IDs were found for
          this business.
        </Typography>
      )}

      {!isLoading && !summaryError && byTechnician.length > 0 && (
        <StAdjustmentsRollupTable columns={PREVIEW_COLUMNS}>
          <StAdjustmentsPreviewHeader />
        </StAdjustmentsRollupTable>
      )}
    </PayBreakdownPaneShell>
  );
};
